export const strings = {
    contributor: "CONTRIBUTOR",
    sessionExpiredMsg: "Your ession has expired. Login back to manage your account!",
    sessionExpireMsg: "Your session has expired. Please login back to manage your account.",
    sessionExpiringSoon: "Session Expiring Soon",
    sessionExpired: "Session Expired",
    sessionWillExpire: "For the safety of your privacy, your session will expire in",
    someThingWentWrong: "Something went wrong!!",
    sessionSignOut: "Signout",
    sessionSignIn: "Stay Signed In",
    sessionExpire: "Your session is about to expire!",
    sessionInactive: "You have been inactive for a while. for the safety of your privacy, your session will expire in ",
    sessionMinutes: "Minutes.",
    noData: "No data",
    ok: "Okay",
    na: "N/A",
    note: "Note!",
    note1: "By changing the current preferred currency, it may reflects to all users.",
    note2: "If you change currency it will take around ",
    noteTime: "30 minutes ",
    note3: "to reflect.",
    lorem: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"

}